import React from 'react'
import * as searchTypes from './searchFormType'
import useLookupService from '../../../../../services/lookup/useLookupService'
import useAuthenStore from '../../../../../stores/authen/authenStore'
import useTranslate from '../../../../../i18n/useTranslate'
import { FormApi } from 'final-form'
import useCheckPermission from '../../../../../utilities/checkPermission'

const PENDING_AND_RISK_LUT = [
    { id: '1', name_th: 'Pending', name_en: 'Pending' },
    { id: '2', name_th: 'โครงการมีความเสี่ยงสูง', name_en: 'High-risk project' },
]

const PROGRESS_OVERDUE_LUT = [
    { id: '1', name_th: 'ไม่เกินกำหนด', name_en: 'On time' },
    { id: '2', name_th: 'เกินกำหนด', name_en: 'Overdue' },
]

const useSearchForm = (props: searchTypes.UseSearchType) => {
    const { onGetListItem, onClickClear } = props
    const translate = useTranslate()
    const callLookup = useLookupService()
    const [category, setCategory] = React.useState<searchTypes.OptType[]>([])
    const [status, setStatus] = React.useState<searchTypes.OptType[]>([])
    const [projectTypes, setProjectTypes] = React.useState<searchTypes.OptType[]>([])
    const [submissionProcess, setSubmissionProcess] = React.useState<searchTypes.OptType[]>([])
    const [pendingAndRisk, setPendingAndRisk] = React.useState<searchTypes.OptType[]>([])
    const [progressOverdue, setProgressOverdue] = React.useState<searchTypes.OptType[]>([])
    const checkPermission = useCheckPermission()

    const {
        profile: { userGroupId },
    } = useAuthenStore()

    React.useEffect(() => {
        //ดักจับการเปลี่ยนภาษา
        if (userGroupId) {
            getCategory()
            getSubmissionProcess()
            getStatus()
            getProjectTypes()
            getPendingAndRisk()
            getProgressOverdue()
        }
    }, [translate.languageStore.currentLanguage, userGroupId])

    const getCategory = async () => {
        const res = await callLookup.callProjectSubmitTypeLut()
        const filterCondition = res.result.filter((item) => {
            return item.isCondition
        })
        const formatedData = filterCondition.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })
        setCategory(formatedData)
    }

    const getStatus = async () => {
        const res = await callLookup.callStatusLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })

        setStatus(formatedData)
    }

    const getSubmissionProcess = async () => {
        const res = await callLookup.callSubmittedStatusLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })

        setSubmissionProcess(formatedData)
    }

    const getProjectTypes = async () => {
        const res = await callLookup.callProjectTypeLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })

        setProjectTypes(formatedData)
    }

    const getPendingAndRisk = () => {
        const isTH = translate.languageStore.currentLanguage === translate.languageKey.th
        const formatted = PENDING_AND_RISK_LUT.map((itm) => ({
            label: isTH ? itm.name_th : itm.name_en,
            value: String(itm.id),
        }))
        setPendingAndRisk(formatted)
    }

    const getProgressOverdue = () => {
        const isTH = translate.languageStore.currentLanguage === translate.languageKey.th
        const formatted = PROGRESS_OVERDUE_LUT.map((itm) => ({
            label: isTH ? itm.name_th : itm.name_en,
            value: String(itm.id),
        }))
        setProgressOverdue(formatted)
    }

    const handleClickSubmit = (val: any) => {
        onGetListItem(val)
    }
    const handleEnterSearch = (val: any) => {
        onGetListItem(val)
    }
    const handleClickClear = (form: FormApi<searchTypes.TReturnForm, Partial<searchTypes.TReturnForm>>) => {
        // form.reset()
        // form.restart()
        onClickClear()
    }
    const handleChangCategory = (val: searchTypes.OptType) => {}
    const handleChangStatus = (val: searchTypes.OptType) => {}
    const handleChangProjectName = (val: any) => {}
    return {
        onClickSubmit: handleClickSubmit,
        onClickClearForm: handleClickClear,
        onChangeCategory: handleChangCategory,
        onChangeStatus: handleChangStatus,
        onChangeProjectName: handleChangProjectName,
        handleEnterSearch,
        lutCategory: category,
        lutStatus: status,
        lutSubmissionProcess: submissionProcess,
        lutProjectTypes: projectTypes,
        lutPendingAndRisk: pendingAndRisk,
        lutProgressOverdue: progressOverdue,
        isOfficer: checkPermission.isUserAdmin(),
        isCommittee: checkPermission.isUserCommittee(),
        irb: checkPermission.irb(),
    }
}

export default useSearchForm
